import { BlockTitle } from "framework7-react";

const OverviewSection = ({ title, className, children }) => (
  <div className={className}>
    <BlockTitle className="overview-section-title">{title}</BlockTitle>
    {children}
  </div>
);

export default OverviewSection;
